import React from 'react';
import { APP_CONTAINER_ROUTES } from '@/navigators/routes';
import { AppContainerStackParams } from '@/navigators/types';
import { PaymentDetailComponent } from '@/components/payments/payment-detail-component';
import { StackScreenProps } from '@react-navigation/stack';

export type Props = StackScreenProps<
  AppContainerStackParams,
  APP_CONTAINER_ROUTES.PaymentDetail
>;

export const PaymentDetailScreen: React.FC<Props> = ({ route }) => {
  const { paymentBatchUUID } = route.params;
  return <PaymentDetailComponent paymentBatchUUID={paymentBatchUUID} />;
};
